<template>
  <div>
    <b-modal hide-footer centered size="xl" v-model="visible">
      <template #modal-title>Order History </template>

      <div class="d-flex flex-wrap align-items-center w-100">
        <b-form
          @submit.prevent="filter"
          class="filters rounded p-1 d-flex align-items-center flex-wrap col-12"
        >
          <div class="col-sm-4 col-12 p-50 d-flex align-items-center">
            <!-- <div class="mr-50">
            <b-form-checkbox v-model="selectAll"></b-form-checkbox>
          </div> -->
            <v-select
              :options="types"
              v-model="type"
              label="label"
              :reduce="(option) => option.value"
              :searchable="false"
              placeholder="Display on the page"
              class="w-100"
            ></v-select>
          </div>

          <div class="col-sm-5 col-12 d-flex align-items-center p-50">
            <b-form-input
              placeholder="search"
              v-model.trim="search"
              :disabled="!type"
            />
          </div>
          <div class="col-sm-3 col-12 p-50">
            <b-button class="w-100" type="submit" :disabled="!search">
              <span class="text-muted h5"> Filtering</span>
            </b-button>
          </div>
        </b-form>
      </div>

      <data-table :fields="fields" :items="orderData" :loading="loading">
        <template #account="{ data }">
          <span> {{ data.item.account || "-" }} </span>
        </template>
        <template #close_price="{ data }">
          <span> {{ data.item.close_price || "-" }} </span>
        </template>
        <template #close_time="{ data }">
          <span> {{ data.item.close_time || "-" }} </span>
        </template>
        <template #commission="{ data }">
          <span> {{ data.item.commission || "-" }} </span>
        </template>
 
        <template #created_at="{ data }">
          <span> {{ data.item.created_at || "-" }} </span>
        </template>
        <template #lots="{ data }">
          <span> {{ data.item.lots || "-" }} </span>
        </template>
        <template #magic_number="{ data }">
          <span> {{ data.item.magic_number || "-" }} </span>
        </template>
        <template #open_price="{ data }">
          <span> {{ data.item.open_price || "-" }} </span>
        </template>
        <template #placed_type="{ data }">
          <span> {{ data.item.placed_type || "-" }} </span>
        </template>
        <template #profit="{ data }">
          <span> {{ data.item.profit || "-" }} </span>
        </template>
        <template #rate_close="{ data }">
          <span> {{ data.item.rate_close || "-" }} </span>
        </template>
        <template #rate_margin="{ data }">
          <span> {{ data.item.rate_margin || "-" }} </span>
        </template>
        <template #rate_open="{ data }">
          <span> {{ data.item.rate_open || "-" }} </span>
        </template>
        <template #stop_loss="{ data }">
          <span> {{ data.item.stop_loss || "-" }} </span>
        </template>
        <template #swap="{ data }">
          <span> {{ data.item.swap || "-" }} </span>
        </template>
        <template #symbol="{ data }">
          <span> {{ data.item.symbol || "-" }} </span>
        </template>
        <template #ticket="{ data }">
          <span> {{ data.item.ticket || "-" }} </span>
        </template>
        <template #type="{ data }">
          <span> {{ data.item.type || "-" }} </span>
        </template>
      </data-table>
      <div class="w-100 d-flex flex-wrap align-items-center py-2">
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="lg"
          pills
          class="my-2 d-flex justify-content-center"
        >
        </b-pagination>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BFormGroup,
  BButton,
  BFormTextarea,
  BPagination,
  BForm,
  BFormInput,
} from "bootstrap-vue";
import Loader from "@core/components/loader/Loader.vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import VSelect from "vue-select";

import qs from "qs";
export default {
  components: {
    BPagination,
    BModal,
    BFormGroup,
    BButton,
    BFormTextarea,
    Loader,
    DataTable,
    BForm,
    BFormInput,
    VSelect,
  },
  props: {
    showModal: {
      status: Boolean,
      default: false,
    },
    title: {
      status: String,
      default: " ",
    },
  },
  data() {
    return {
      loading: false,
      orderData: [],
      currentPage: 1,
      pagination: {},
      type: "",
      search: "",
      filterObj: {},
      types: [
        { label: "Account", value: "account" },
      ],
      fields: [
        { key: "account", label: "account" },
        { key: "close_price", label: "close price" },
        { key: "close_time", label: "close time" },
        { key: "commission", label: "commission" },
        { key: "created_at", label: "created at" },
        { key: "lots", label: "lots" },
        { key: "magic_number", label: "magic number" },
        { key: "open_price", label: "open price" },
        { key: "placed_type", label: "placed type" },
        { key: "profit", label: "profit" },
        { key: "rate_close", label: "rate close" },
        { key: "rate_margin", label: "rate margin" },
        { key: "rate_open", label: "rate open" },
        { key: "stop_loss", label: "stop loss" },
        { key: "swap", label: "swap" },
        { key: "symbol", label: "symbol" },
        { key: "ticket", label: "ticket" },
        { key: "type", label: "type" },
      ],
    };
  },
  watch: {
    async type(val) {
      this.search = await "";
    },
    currentPage(val) {
      this.getOpenHistory(val);
    },

    search(val) {
      if (!val) {
        this.filterObj = {};
        this.getOpenHistory();
      }
    },
  },
  computed: {
    visible: {
      get() {
        return this.showModal;
      },
      set(val) {
        this.$emit("close", val);
      },
    },
  },
  async created() {
    await this.getOpenHistory();
  },
  methods: {
    filter() {
      if (this.type) {
        this.filterObj = {};
        this.filterObj[this.type] = this.search;
        this.getOpenHistory();
      }
    },
    async getOpenHistory(page) {
      this.loading = true;
      try {
        const params = {
          per_page: 3,
          page: page || 1,
          filter: this.filterObj,
        };
        const { data } = await this.$http.get(
          `panel/competitions/${this.$route.params.id}/order_histories`,
          {
            params,
            paramsSerializer: (params) => {
              return qs.stringify(params);
            },
          }
        );
        this.orderData = data.data;
        this.pagination = await data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (e) {}
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.btn {
  background-color: #252531;
  border: 1px solid #ffffff0d;
}
@media (min-width: 576px) {
  .modal-dialog {
    width: 560px !important;
  }
}
</style>
